module.exports = __webpack_public_path__ + "static/media/S3N12-1.95323d3d.svg";